import React from 'react';
import { cmxDateTime } from '@codametrix/ui-common';
import './styles/index.scss';
/**
 * Readable date + time and actor for Activity tab meta line:
 * "Weekday, Month D, YYYY h:mm AM | username"
 * Uses cmxDateTime so bracketed API timestamps (e.g. +0000[UTC]) parse like the rest of the app.
 */
export function formatActivityDateTime(
  timestamp: string | null | undefined
): string {
  if (!timestamp) return '';
  const datePart = cmxDateTime.format(timestamp, 'dddd, MMMM D, YYYY');
  const timePart = cmxDateTime.format(
    timestamp,
    cmxDateTime.FORMATS.TIME_WITHOUT_SECONDS
  );
  return `${datePart} ${timePart}`;
}

export function formatActivityMetaLine(
  timestamp: string | null | undefined,
  actor: string
): string {
  const actorPart = actor.trim() || '—';
  const dateTime = formatActivityDateTime(timestamp);
  if (!dateTime) {
    return `| ${actorPart}`;
  }
  return `${dateTime} | ${actorPart}`;
}

export const ActivityCodeChip: React.FC<{ children?: React.ReactNode }> = ({
  children
}) => (
  <span className="activity-code-chip">
    {children === undefined || children === null || children === '' ? (
      <span className="activity-code-chip-empty" aria-hidden="true" />
    ) : (
      children
    )}
  </span>
);

export type ActivityEntryProps = {
  timestamp?: string | null;
  actor: string;
  primary: React.ReactNode;
  detail?: React.ReactNode;
};

export const ActivityEntry: React.FC<ActivityEntryProps> = ({
  timestamp,
  actor,
  primary,
  detail
}) => (
  <span className="activity-item">
    <span className="activity-entry-primary">{primary}</span>
    {detail ? <span className="activity-message">{detail}</span> : null}
    <span className="activity-entry-meta">
      {formatActivityMetaLine(timestamp, actor)}
    </span>
  </span>
);
